import IEC61850Server from "../../images/systemComponents/IEC61850Server.png";
import IEC61850WAN from "../../images/systemComponents/IEC61850WAN.svg";
import Layout from "../../components/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61850 (Сервер)
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Сервер МЭК 61850 </b>  в SCADA NPT Compact используется для передачи данных по стандарту МЭК 61850-90-2. Передача данных по стандарту МЭК 61850-90-2 используется для обмена информацией между удалёнными объектами и централизованными системами управления.
                    </p>
                    <img
                        src={IEC61850Server}

                        className="mb-4 w-100 "
                        alt="IEC61850 Сервер"
                    />

                    <p>МЭК 61850-90-2 позволяет передавать данные между подстанциями через WAN (Wide Area Network), что особенно полезно для крупных энергосистем.</p>
                    <img
                        src={IEC61850WAN}

                        className="mb-4 w-100 "
                        alt="IEC61850 WAN"
                    />


                </div>

            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'МЭК 61850 (Сервер)',
    description: 'Сервер МЭК 61850  в SCADA NPT Compact используется для передачи данных по стандарту МЭК 61850-90-2. Передача данных по стандарту МЭК 61850-90-2 используется для обмена информацией между удалёнными объектами и централизованными системами управления.'
}
//export const doNotPrerender = false;
